import React, { useState } from "react";
import Container from "../components/Layout/Container";
import { QueryClient, QueryClientProvider } from "react-query";
import AlsoIncomeModuleScreen from "./AlsoIncomeModuleScreen";

export const queryProductsClient = new QueryClient();

const lockedStatusByTab = {
  all_documents: undefined,
  require_review: "require_review",
  pending: "pending",
};

export default function AlsoIncomesIndex({ match, history }) {
  const [tabId, setTabId] = useState("all_documents");
  console.log(tabId, "tabId");
  const renderTabContent = () => {
    if (!(tabId in lockedStatusByTab)) return null;
    return (
      // key forces a remount so each tab starts from fresh filter/page state
      <AlsoIncomeModuleScreen
        key={tabId}
        match={match}
        history={history}
        tabId={tabId}
        setTabId={setTabId}
        lockedStatus={lockedStatusByTab[tabId]}
      />
    );
  };

  return (
    <>
      <QueryClientProvider client={queryProductsClient}>
        {renderTabContent()}
      </QueryClientProvider>
    </>
  );
}
